

































import {Component} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';
import {Action} from '@/store';

@Component
export default class LoginView extends CommonVue {
    public username: string|null = null;
    public password: string|null = null;
    public busy: boolean = false;

    public beforeMount() {
        this.busy = false;
    }

    public async onSubmit() {
        this.busy = true;
        try {
            await this.$store.dispatch(
                Action.LOGIN,
                {
                    username: this.username,
                    password: this.password,
                }
            );
        }
        finally {
            this.busy = false;
            this.password = null;
        }
    }

    // noinspection JSUnusedGlobalSymbols
    public beforeDestroy() {
        this.$bus.$emit(BusEvent.CLEAR_ERROR);
    }
}
